import { MessageModel } from "./messageModel";

export interface MessageThreadModel {
  messageThreadID?: number;

  threadName?: string;
  
  patientID?: number;
  patientPhotoID?: number;
  patientName?: string;

  count?: number;
  unread?: number;
  date?: Date;
  noLongerInThread?: boolean;

  messages?: Array<MessageModel>;
}
